import React, { useContext } from 'react'
import styled, { css } from 'styled-components'
import { navigate } from 'raviger'
import { Row, Col } from 'react-bootstrap'
import nologo from 'images/snapp-icon.png'
import { Permission, Link, OrgImage, ButtonLabel } from 'components'
import CurrencyFormat from 'react-currency-format'
import { DATE_MOMENT_FORMAT } from 'utils/constants'
import moment from 'moment'
import { I18nContext } from 'i18n'
import { device } from 'utils/device'
import theme from '../../themes/default'

const Organization = ({
  total,
  full,
  detail,
  fullName,
}) => {
  const { translate } = useContext(I18nContext)

  const {
    id,
    name,
    logoURL,
    peerComparisonFactor,
    nspaMemberData,
  } = detail || {}

  const {
    scholarshipMinimumAward,
    scholarshipMaximumAward,
  } = peerComparisonFactor || {};

  const {
    membershipExpiration,
    totalNumberStudents,
    totalDollarAmount,
  } = nspaMemberData || {}

  const handleRedirect = () => {
    navigate('/member-detail')
  }

  const renderFull = () => {
    return (
      <div>
        <ImageContainer>
          {id && <OrgImage logo={logoURL} nologo={nologo} orgId={id} />}
        </ImageContainer>
        <div>
          <Title>{name}</Title>
        </div>
        <OrgData>
          <p>
            <span>Organization Type:</span> {detail?.organizationType}
          </p>
          <p>
            <span>Unique Programs:</span> {total}
          </p>
          <p>
            <span>Award Range:</span>{' '}
            {!!scholarshipMinimumAward && (
              <CurrencyFormat
                value={scholarshipMinimumAward}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                suffix={scholarshipMaximumAward ? ' - ' : ''}
              />
            )}
            {!!scholarshipMaximumAward && (
              <CurrencyFormat
                value={scholarshipMaximumAward}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
              />
            )}
          </p>

          {totalNumberStudents > 0 && (
            <p>
              <span>
                Annual Awards Given:
              </span>{' '}
              <CurrencyFormat
                value={totalNumberStudents}
                displayType={'text'}
                thousandSeparator={true}
              />
            </p>
          )}
          {totalDollarAmount > 0 && (
            <p>
              <span>
                Total Award Amount:
              </span>{' '}
              <CurrencyFormat
                value={totalDollarAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
              />
            </p>
          )}
        </OrgData>
        <LinkContainer>
          {detail && (
            <StyledLink small="true" href="/member-detail">
              View my organization detail.
            </StyledLink>
          )}
        </LinkContainer>
        <Permission permission={['scholarships']}>
          <LinkContainer>
            <StyledLink small="true" href="/search/advanced/programs">
              Search the full NSPA database.
            </StyledLink>
          </LinkContainer>
        </Permission>
        <Permission permission={['canManageMemberScholarships']}>
          {detail && (
            <ButtonWrapper>
              <ButtonLabel
                color={theme.palette.secondary[0]}
                onClick={() => navigate(`/data-center`)}
                permissions={['canManageMemberScholarships']}
              >
                {translate('edit_my_programs')}
              </ButtonLabel>
            </ButtonWrapper>
          )}
        </Permission>
      </div>
    )
  }

  const renderMin = () => {
    return (
      <MemeberInformation onClick={handleRedirect}>
        <Col xs={3}>
          <LogoMin src={logoURL || nologo} />
        </Col>
        <Col xs={8}>
          <MemberTitle>{name}</MemberTitle>
          {fullName && (
            <MemberP>{`${fullName}`}</MemberP>
          )}
          <MemberP>
            {translate('organization_through')}
          </MemberP>
          <MemberYear>
            {/* format date like Jun 20, 2024 */}
            {moment(membershipExpiration?.split('T')[0]).format(DATE_MOMENT_FORMAT)}
          </MemberYear>
        </Col>
      </MemeberInformation>
    )
  }

  return full ? renderFull() : renderMin()
}

const LinkContainer = styled.div`
  line-height: 2rem;
`

const LogoMin = styled.img`
  max-width: 75px;
`

const Title = styled.h4`
  margin-top: 0.8rem;
  font-weight: 600;
  color: #3f4040;
  font-size: 2rem;
`

const OrgData = styled.div`
  margin: 1.5rem 0;
  color: #3f4040;

  p {
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 300;

    span {
      &:first-child {
        font-weight: 600;
      }
    }
  }
`

const StyledLink = styled(Link)`
  font-weight: 300;
  font-size: 1rem;
`

const MemeberInformation = styled(Row)`
  margin: 0.5rem 0;
  cursor: pointer;
`

const MemberTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0.5rem;
`

const memberDivStyle = css`
font-size: 0.9rem;
white-space: nowrap;
font-weight: 300;
`

const MemberP = styled.div`
  ${memberDivStyle}
`

const MemberYear = styled.div`
  ${memberDivStyle}
  font-weight: 600;
`

const ImageContainer = styled.div`
  @media ${device.mobileL} {
    text-align: center;
  }
`

const ButtonWrapper = styled.div`
  margin-top: 1rem;
  max-width: 20rem;
`

export default Organization
